// Spacing:
export const SPACING_X1 = 4;
export const SPACING_X3 = SPACING_X1 * 3;

// Widths:
export const SIDE_NAV_WIDTH_PX = 252;
export const SIDE_NAV_WIDTH_COLLAPSED_PX = 72;
export const SCROLLBAR_SIZE_PX = 8;

export const MODAL_WIDTH = 480;
